import { createClient } from "@supabase/supabase-js";
import { auth } from "../firebaseConfig";

const url = import.meta.env.VITE_SG_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SG_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  console.warn(
    "[sgSupabase] Faltan VITE_SG_SUPABASE_URL o VITE_SG_SUPABASE_ANON_KEY. La seccion SG no podra leer datos."
  );
}

export const sgSupabase = createClient(
  url ?? "https://sg-not-configured.supabase.co",
  anonKey ?? "sg-not-configured",
  {
    accessToken: async () => {
      const user = auth.currentUser;
      if (!user) return null;
      return user.getIdToken();
    },
  }
);
